import lang from "@/views/modules/Opportunitys/language/en";

let searchFieldsDef = {
    'opportunity_title': {
        label: lang.LBL_OPPORTUNITY_TITLE,
    },
    'opportunity_year': {
        label: lang.LBL_OPPORTUNITY_YEAR,
        type:'select',
        field_infos:'opportunity_year',
    },
    'opportunity_type': {
        label: lang.LBL_OPPORTUNITY_TYPE,
        type:'select',
        field_infos:'scheme_type'
    },
    'opportunity_funder': {
        label: lang.LBL_OPPORTUNITY_FUNDER,
    },
    'deadline': {
        label: lang.LBL_OPPORTUNITY_DEADLINE,
        type:'daterange'
    },
    'status': {
        label: lang.LBL_STAGE,
        type: 'checkbox',
        field_infos:'opportunity_stage_dom',
    },
};
export default { searchFieldsDef }